(function () {
	'use strict';

	angular
		.module('wizard-english-test.services')
		.service('HttpService', HttpService);

	function HttpService($http, ROUTES) {
		const HttpService = {
			get,
			getExternal,
			post,
			put,
			delete: remove
		};

		return HttpService;

		function get(url, config) {
			return $http
				.get(`${ROUTES.API}${url}`, config)
				.then(response => {
					if (response != null && response != undefined)
						return response.data;

					return response;
				});
		}

		function getExternal(url) {
			return $http
				.get(url)
				.then(response => {
					if (response != null && response != undefined) {
						return response.data;
					}

					return response;
				});
		}

		function post(url, data, config) {
			return $http
				.post(`${ROUTES.API}${url}`, data, config)
				.then(response => {
					if (response != null && response != undefined)
						return response.data;

					return response;
				});
		}

		function put(url, data) {
			return $http
				.put(`${ROUTES.API}${url}`, data)
				.then(response => {
					if (response != null && response != undefined)
						return response.data;

					return response;
				});
		}

		function remove(url, config) {
			return $http
				.delete(`${ROUTES.API}${url}`, config)
				.then(response => {
					if (response != null && response != undefined)
						return response.data;

					return response;
				});
		}
	}
})();